<script>
	import { Table } from "sveltestrap";
	import CustomModal from "../../../components/CustomModal/CustomModal.svelte";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import { convert } from "../../../services/helpers";
	import { blackoutCarData, editBlackoutData } from "../../../store/store";

	function handleRemove(id) {
		let cars = $blackoutCarData.splice(id, 1);
		blackoutCarData.set($blackoutCarData);
	}
</script>

{#if $blackoutCarData}
	<LoaderContainer>
		<Table responsive hover>
			<thead>
				<tr>
					<th>Delete</th>
					<th>Car plate no.</th>
					<th>Make</th>
					<th>Model</th>
					<th>Carpark</th>
					<th>Active Start Date</th>
					<th>Active End Date</th>
					<th>Status</th>
				</tr>
			</thead>
			<tbody>
				{#each $blackoutCarData as { id, vehicleMakeName, vehicleModelName, car_park_id, carParkName, car_park_owner_id, plateNumber, pricing_group_name, activeFrom, activeTo, status }, index}
					<tr>
						<td>
							<!-- svelte-ignore a11y-click-events-have-key-events -->
							<img
								class="close"
								style="width: 25px; height: 28px; cursor: pointer;"
								src="https://img.icons8.com/fluency/48/000000/delete-forever.png"
								on:click={() => handleRemove(index)}
								alt="Remove"
							/>
						</td>
						<td>
							<p>
								<span class="link link-text">
									{plateNumber}
								</span>
							</p>
						</td>
						<td>
							<p>
								<span> {vehicleMakeName} </span>
							</p>
						</td>
						<td>
							<p>
								<span>{vehicleModelName}</span>
							</p>
						</td>
						<td>
							<p>
								<span> {carParkName} </span>
							</p>
						</td>
						<td>
							<p>
								<span>{convert(activeFrom)} </span>
							</p>
						</td>
						<td>
							<p>
								<span>{convert(activeTo)} </span>
							</p>
						</td>
						<td>
							{#if status === 1}
								<p class="status-bar status-bar-1">Active</p>
							{:else if status === 0}
								<p class="status-bar status-bar-3">Inactive</p>
							{/if}
						</td>
					</tr>
				{/each}
			</tbody>
		</Table>
		<!-- {#if data.totalCount == 0}
		<p class="text-center">No data to display</p>
	{/if}
	<CustomPaginate totalRecord={data.totalCount} /> -->
		<CustomModal />
	</LoaderContainer>
{:else if $editBlackoutData.stats === true}
	<LoaderContainer />
{/if}
